import { createStandardAction } from 'typesafe-actions';

export const updateSubtitlesVisibility = createStandardAction(
  'subtitles/TOGGLE_VISIBILITY'
)<boolean | undefined>();

export const changeCurrentSubtitlesName = createStandardAction(
  'subtitles/CHANGE_CURRENT_SUBTITLES_NAME'
)<string>();
